module.exports = __webpack_public_path__ + "img/success2.12fb5539.svg";